import { apiFetch, getCurrentUser, getToken, saveSession } from "./Api";

// What the signed-in account is -- which category (school, gym, ...) and which modules that category switches on. The
// sign-in flow stores it next to the session; sessions from before categories hold neither and are treated as school.
export const SCHOOL_MODULES = [
  "COURSES",
  "MEETINGS",
  "SCHOOL_STRUCTURE",
  "LESSONS",
  "EXAMS",
  "NEWS",
  "GALLERY",
  "RESOURCES",
  "INBOX",
];

export function currentCategory() {
  const user = getCurrentUser();
  return (user && user.categoryId) || "school";
}

export function currentModules() {
  const user = getCurrentUser();
  return user && Array.isArray(user.modules) ? user.modules : SCHOOL_MODULES;
}

export function hasModule(module) {
  return currentModules().indexOf(module) >= 0;
}

/** Re-reads the account from the server and keeps its category / modules with the session (after an owner change, or for
 *  a session saved before categories existed). Never throws: the menu simply stays as it was. */
export function refreshAccountInfo() {
  return apiFetch("/teachers/me")
    .then((me) => {
      const user = getCurrentUser();
      if (user && getToken()) {
        saveSession(getToken(), { ...user, categoryId: me.categoryId, modules: me.modules });
      }
      return me;
    })
    .catch(() => null);
}
